import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ImprimirLabel from '@/components/ImprimirLabel.vue'
import ImprimirLabelSmall from '@/components/ImprimirLabelSmall.vue'
import ImprimirDescuento from '@/components/ImprimirDescuento/Index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },

  {
    path: '/label',
    name: 'Label',
    component: ImprimirLabel
  },
  {
    path: '/labelsmall',
    name: 'LabelSmall',
    component: ImprimirLabelSmall
  },
  {
    path: '/discount',
    name: 'Descuento',
    component: ImprimirDescuento
  },
]

const router = new VueRouter({
  routes
})

export default router
